module.exports = __webpack_public_path__ + "img/bg06.b49174f5.gif";